export const stage = {
  intro: 'intro',
  deals: 'deals',
  customer: 'customer',
  staff: 'staff',
  deal: 'deal',
  frame: 'frame',
  vision: 'vision',
  configuration: 'configuration',
  order: 'order',
  payment: 'payment',
  avatar: 'avatar',
  dev: 'dev',
} as const

export type Stage = (typeof stage)[keyof typeof stage] | null

export const preset = {
  empty: 'empty',
  intro: 'intro',
  deals: 'deals',
  staff: 'staff',
  customer: 'customer',
  main: 'main',
  avatar: 'avatar',
  dev: 'dev',
} as const

export type Preset = (typeof preset)[keyof typeof preset]

export const presets: Record<Preset, Stage[]> = {
  empty: [null],
  intro: ['intro'],
  deals: ['deals'],
  staff: ['staff'],
  customer: ['customer'],
  main: ['deal', 'frame', 'vision', 'configuration', 'order', 'payment'],
  avatar: ['frame', 'vision', 'deal', 'configuration', 'order', 'payment'],
  dev: ['dev'],
}

export const listPresets = Object.keys(presets) as Preset[]

export const modalAvailableStages = [/* 'frame', 'vision',*/ 'configuration']

export type Labels = (string | null)[]
